



















































import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchOrdenesCompra } from './fetchOrdenesCompra';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import { boolean } from 'yup/lib/locale';
import { NumericDictionary } from 'lodash';

@Component({
  components: {
    DatePicker,
    MantenedorGrid,
    FormFieldsContainer,
  },
})
export default class ModalIncluirCostos extends Vue {
  @Prop({ required: true }) compranumero: any;

  ordesList: any;
  dataCosts: Array<Object> = [];

  async getEquipos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchOrdenesCompra(
      {
        compra: this.compranumero,
      },
      'conectaOrdenesCompra/get_costos_importacion'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          //console.log(data.data.data.LISTA);
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar los equipos', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getEquipos();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  gridOptions: GridOptions;
  isEditing: boolean = false;
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  estadoGrillaVm: EstadoGrillaVm;
  serverSide: any;

  formatMoney(params: any) {
    const numericValue = parseFloat(params.value);
    if (!isNaN(numericValue)) {
      return numericValue
        .toFixed(2)
        .replace('.', ',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    return params.value;
  }

  constructor() {
    super();
    let self = this;
    this.columnDefs = [
      {
        headerName: 'Fecha Carga',
        field: 'costofecha_carga',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,
        valueFormatter: this.formatFecha,
      },
      {
        headerName: 'Clausula Compra',
        field: 'costoclausula',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,
      },
      {
        headerName: 'Tipo Flete',
        field: 'costotipo_flete',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,
      },
      {
        headerName: 'Observación',
        field: 'costoobservacion',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,
      },
      {
        headerName: 'Precio Tipo Cambio',
        field: 'costotipo_cambio',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,
        valueFormatter: this.formatMoney,
      },
      {
        headerName: 'T/C Aduana',
        field: 'costoaduana',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,

        valueFormatter: this.formatMoney,
      },
      {
        headerName: 'Flete',
        field: 'costoflete',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,

        valueFormatter: this.formatMoney,
      },
      {
        headerName: 'Flete Local',
        field: 'costoflete_local',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,

        valueFormatter: this.formatMoney,
      },
      {
        headerName: 'Desconsolidación',
        field: 'costodesconsolidacion',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,

        valueFormatter: this.formatMoney,
      },
      {
        headerName: 'Derechos',
        field: 'costoderechos',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,

        valueFormatter: this.formatMoney,
      },
      {
        headerName: 'Almacenaje',
        field: 'costoalmacenaje',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,

        valueFormatter: this.formatMoney,
      },
      {
        headerName: 'Agencia Aduana',
        field: 'costoagencia_aduana',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,

        valueFormatter: this.formatMoney,
      },
      {
        headerName: 'Seguro',
        field: 'costoseguro',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,

        valueFormatter: this.formatMoney,
      },
      {
        headerName: 'Cantidad Equipos Cargados',
        field: 'costocantidad_equipos',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,
      },
      {
        headerName: 'Total Flete y otros',
        field: 'costototal_otros',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,
        valueFormatter: this.formatMoney,
      },
      {
        headerName: 'Costo Unitario Internación',
        field: 'costovalor_unitario',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,
        valueFormatter: this.formatMoney,
      },
      {
        headerName: 'Precio De Compra',
        field: 'costoprecio_compra',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,
        valueFormatter: this.formatMoney,
      },
      {
        headerName: 'Precio Total Compra',
        field: 'costoprecio_total',
        resizable: true,
        sortable: true,
        width: 200,
        lockPinned: true,
        valueFormatter: this.formatMoney,
      },
    ];

    this.gridOptions = {
      singleClickEdit: true,
      pagination: true,
      paginationPageSize: 6, //Solución Paginación
      //cacheBlockSize: 50, //Solución Paginación
      //paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      //rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          //cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,
      onCellEditingStopped: function(event) {},
      onCellEditingStarted: function(event) {
        self.isEditing = true;
      },
      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  formatFecha(fecha: any) {
    return moment(fecha.value).format('DD/MM/YYYY HH:mm:ss');
  }

  mounted() {}

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  //abstract;

  //propiedades globales
  loadingService = new LoadingService();
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;

  //Interface
  estadoSwitch: boolean = false;

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  //@Watch('show')
  async onPropertyChanged(value: boolean) {
    this.dialog = value;
    this.dialog = value;
    // permisos
    this.setBotonNav();
  }

  setBotonNav() {}

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }

  closeModal() {
    this.$validator.reset();
    document.getElementById('cardDivTV').scrollIntoView(true);
    this.$emit('modalAsociacionEmit', false);
  }

  confirmCallback(val: any) {}
}
